// components/Loader.jsx
import React from 'react';
import '../../CSS/Global.css';

const Loader = () => (
  <div className="fullpage-loader">
    <div className="spinner"></div>
    <p>Importing invoices...</p>
  </div>
);

export default Loader;
